import loader from '../moduleLoader.js';

function Paging(button) {
    let resultContainer;
    let totalCount;

    function init() {
        const resultContainerId = button.getAttribute('data-paging-for');
        initPaging();
        button.addEventListener('click', handlePaging);
        button.setAttribute('aria-controls', resultContainerId);
        resultContainer = document.getElementById(resultContainerId);
        resultContainer.setAttribute('aria-live', 'polite');
        totalCount = parseInt(resultContainer.getAttribute('data-total-count'));
        window.addEventListener('FilterUpdate', () => {
            button.parentNode.classList.add('hidden');
        });
        window.addEventListener('ResultUpdated', handleResultUpdated);
    }

    function initPaging() {
        const searchParams = new URLSearchParams(location.search);
        const page = searchParams.get("page") || 0;
        const pastPage = searchParams.get("pastpage") || 0;
        searchParams.set("page", parseInt(page));
        searchParams.set("pastpage", parseInt(pastPage));
        history.replaceState(null, null, `?${searchParams.toString()}`);
    }

    function handleResultUpdated() {       
        resultContainer = document.getElementById(button.getAttribute('data-paging-for'));
        totalCount = parseInt(resultContainer.getAttribute('data-total-count'));    
        if (getItemsCount() >= totalCount) {
            button.parentNode.classList.add('hidden');
        } else {
            button.parentNode.classList.remove('hidden');
        }
    }

    function handlePaging(e) {
        e.preventDefault();
        button.setAttribute('data-loading', 'true');

        const currentButton = e.currentTarget.getAttribute('data-paging-for');
        const queryParameter = currentButton == "pastpage" ? currentButton : "page";
        const searchParams = new URLSearchParams(location.search);
        const page = searchParams.get(queryParameter) || 0;
        searchParams.set(queryParameter, parseInt(page) + 1);

        history.replaceState(null, null, `?${searchParams.toString()}`);

        fetchItems(searchParams, function (html) {
            setTimeout(()=> {
                appendNewItems(html);
            }, 500);
            
        });
    }

    function fetchItems(searchParams, callback) {
        const request = new XMLHttpRequest();
        const url = button.getAttribute('data-url') + '?' + searchParams.toString();

        request.onreadystatechange = function () {
            if (this.readyState !== 4) return;
            if (this.status !== 200) {
                //console.log('Error fetching items');
                return;
            }
            callback(this.responseText);
        };

        request.open('POST', url, true);
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        request.send();
    }

    function appendNewItems(html) {

        removePlaceholders();
        //console.log(html);
        
        var template = document.createElement('template');
        template.innerHTML = html;
    
        //console.log(template);
        var doc = template.content;
        //console.log(doc);
        const children = doc.children;
        
        if(doc.querySelectorAll('ol, ul').length > 0) {
            handleNestedItems(doc);
        }
        else { 
            Array.from(children).forEach(child => {
                resultContainer.append(child);
                loader.parseDom(child); 
                // window.dispatchEvent(new CustomEvent('ResultAppending', { detail: child }));
            })              
            if (getItemsCount() >= totalCount) {
                button.parentNode.classList.add('hidden');
            }
        }
        button.removeAttribute('data-loading');
        window.dispatchEvent(new CustomEvent('ResultAppended'));
    }

    function handleNestedItems(doc) {
        const firstListItem = doc.querySelector('body > li:first-child');
        if(firstListItem && document.getElementById(firstListItem.getAttribute('id'))) {
            const items = firstListItem.querySelectorAll('ol > li, ul > li');
            Array.from(items).forEach(item => {
                document.getElementById(firstListItem.getAttribute('id')).querySelector('ul, ol').append(item);
                // window.dispatchEvent(new CustomEvent('ResultAppending', { detail: item }));
                loader.parseDom(item); 
            });
            const remaining = doc.querySelectorAll('body > li:not(:first-child)');
            if(remaining) {
                Array.from(remaining).forEach(item => {
                    resultContainer.append(item);
                    loader.parseDom(item); 
                    // window.dispatchEvent(new CustomEvent('ResultAppending', { detail: item }));
                });
            }        
        }
        else {
            //resultContainer.insertAdjacentHTML('beforeend', doc.body.innerHTML);
            Array.from(doc.children).forEach(child => {
                resultContainer.append(child);
                window.dispatchEvent(new CustomEvent('ResultAppending', { detail: child }));
            })
        }
        if (getItemsCount() >= totalCount) {
            button.parentNode.classList.add('hidden');
        }
    } 

    function getItemsCount() {
        let items;
        if(resultContainer.querySelectorAll('ol, ul').length > 0) {
            items = resultContainer.querySelectorAll('ol ol > li, ul ul > li');            
        } 
        else if(resultContainer.querySelectorAll('tr').length > 0) {
            items = resultContainer.querySelectorAll('tr');
        }
        else {
            items = resultContainer.querySelectorAll(':scope > *:not(.flex-placeholder)'); 
        }
        if(items) {
            return items.length;
        }
    }

    function removePlaceholders() {
        const placeholders = resultContainer.querySelectorAll('.flex-placeholder');
        [].forEach.call(placeholders, function (item) {
            item.remove();
        });
    }

    return {
        init: init
    }
}

loader.add('Paging', Paging);

export default Paging;